import type { ReactNode } from 'react';
import styles from './HelpHint.module.scss';
import React from 'react';

export interface HelpHintProps {
    children: ReactNode;
}

export function HelpHint({ children }: HelpHintProps) {
    return (
        <span className={styles.root}>
            <button type="button" className={styles.badge} aria-label="Подсказка">
                ?
            </button>
            <span className={styles.tip} role="tooltip">
                {children}
            </span>
        </span>
    );
}